import React, { useState, cloneElement, isValidElement } from 'react';
import { Box } from '@mui/material';
import { useScreen } from 'global/styles';
import useStyles from './styles';

/**
 * A responsive split panel component with smooth transitions.
 * - Mobile: Slides between left and right panels (one at a time)
 * - Web: Shows left panel full width, or both panels 50/50 split
 */

let setActiveTabExternal;

export const onNavigateRight = () => {
  if (setActiveTabExternal) setActiveTabExternal(1);
};

export const onNavigateLeft = () => {
  if (setActiveTabExternal) setActiveTabExternal(0);
};

const FlexibleLayout = (props) => {
  const { leftPanel, rightPanel, showRightPanel, defaultRightPanel = null, handleLeftPanelClose, handleRightPanelClose } = props;

  const { isMobile } = useScreen();
  const [activeTab, setActiveTab] = useState(0);
  const classes = useStyles();
  const [highlightedElement, setHighlightedElement] = useState(props.highlightedElement);

  setActiveTabExternal = setActiveTab;

  const onLeftPanelClose = () => {
    handleLeftPanelClose?.();
  };

  const onRightPanelClose = () => {
    setActiveTab(0);
    setHighlightedElement(null);
    handleRightPanelClose?.();
  };

  const withPanelProps = (panel) => {
    return isValidElement(panel)
      ? cloneElement(panel, {
          highlightedElement,
          setHighlightedElement,
          onRightPanelClose,
          onLeftPanelClose,
        })
      : null;
  };

  if (isMobile) {
    return (
      <Box className={classes.container}>
        <Box className={classes.mobileLayout}>
          <Box className={`${classes.mobileSlider} ${showRightPanel ? 'showRight' : ''}`}>
            {/* Left Panel */}
            <Box className={classes.mobilePanel}>
              <Box className={classes.panelContent}>{withPanelProps(leftPanel)}</Box>
            </Box>

            {/* Right Panel */}
            <Box className={classes.mobilePanel}>
              <Box className={classes.panelContent}>{showRightPanel && withPanelProps(rightPanel ?? defaultRightPanel)}</Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  // Web Layout
  return (
    <Box className={classes.container}>
      <Box className={classes.webLayout}>
        {/* Left Panel */}
        <Box className={`${classes.webLeftPanel} ${showRightPanel ? 'split' : ''}`}>
          <Box className={classes.panelContent}>{withPanelProps(leftPanel)}</Box>
        </Box>

        {/* Right Panel */}
        <Box className={`${classes.webRightPanel} ${showRightPanel ? 'visible' : ''}`}>
          <Box className={classes.panelContent}>{showRightPanel && withPanelProps(rightPanel ?? defaultRightPanel)}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FlexibleLayout;
